import { ref } from "vue";
import type { DropdownOption } from "../../redistribution/models/DropdownOption.ts";

export function createDropdownOptionsModule() {
  const rateOfSaleOptions = ref<{ label: string; value: string }[]>([]);

  const warehouseOptions = ref<DropdownOption[]>([]);
  const warehousesLoading = ref(true);
  const warehousesError = ref<string | undefined>(undefined);

  const vendorOptions = ref<DropdownOption[]>([]);
  const vendorsLoading = ref(true);
  const vendorsError = ref<string | undefined>(undefined);

  const collectionOptions = ref<DropdownOption[]>([]);
  const collectionsLoading = ref(true);
  const collectionsError = ref<string | undefined>(undefined);

  function setRateOfSaleOptions(
    options: { label: string; value: string }[]
  ): void {
    rateOfSaleOptions.value = options;
  }

  function setWarehouseOptions(warehouseOptionsArray: DropdownOption[]): void {
    warehouseOptions.value = warehouseOptionsArray;
  }

  return {
    rateOfSaleOptions,
    warehouseOptions,
    warehousesLoading,
    warehousesError,
    vendorOptions,
    vendorsLoading,
    vendorsError,
    collectionOptions,
    collectionsLoading,
    collectionsError,
    setRateOfSaleOptions,
    setWarehouseOptions,
  };
}
